import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Danger from "components/Typography/Danger.jsx";

import { CircularProgress } from '@material-ui/core';

import axios from "axios";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { API_ROOT, SUPPORT_EMAIL } from 'api-config';

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    var uploadToUserId;
    var uploadPath = null;
    var uploadAction = null;
    var uploadButtonName = 'upload';
    if (props.uploadToUserId) {
      uploadToUserId = props.uploadToUserId
    }
    var fileType;
    if (props.fileType) {
      fileType = props.fileType
    }
    if (props.uploadPath) {
      uploadPath = props.uploadPath
    }
    if (props.uploadAction) {
      uploadAction = props.uploadAction
    }
    if (props.uploadButtonName) {
      uploadButtonName = props.uploadButtonName
    }
    this.state = {
      file: null,
      fileDisplayName: null,
      uploadToUserId: uploadToUserId,
      fileType: fileType,
      uploadPath: uploadPath,
      uploadAction: uploadAction,
      uploadButtonName: uploadButtonName,
      fileUploadStatusIndicator: '',
      fileUploadStatusMessage: '',
      fileUploadError: ''
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  handleFileChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        fileDisplayName: file.name
      });
    };
    reader.readAsDataURL(file);
  }
  handleFileUpload() {
    if (!this.state.file) {
      this.setState({
        fileUploadStatusIndicator: '',
        fileUploadStatusMessage: '',
        fileUploadError: "Please select a file to upload."
      });
    } else if (!this.state.uploadPath && !this.state.uploadAction) {
      this.setState({
        fileUploadStatusIndicator: '',
        fileUploadStatusMessage: '',
        fileUploadError: "There was an error uploading the file. Please contact " + SUPPORT_EMAIL + "."
      });
    } else {
      if (this.state.uploadAction) {
        this.state.uploadAction(this.state.file, this.state.fileDisplayName)
      } else {
        const statusIndicator = <CircularProgress size={20}/>
        this.setState({
          fileUploadStatusIndicator: statusIndicator,
          fileUploadStatusMessage: 'uploading...',
          fileUploadError: ''
        });
        const formData = new FormData();
        formData.append('file', this.state.file);
        formData.append('userId', this.state.uploadToUserId);
        formData.append('filename', this.state.fileDisplayName);
        axios.post(`${API_ROOT}/` + this.state.uploadPath + `/`, formData, { headers: getApiHeaders() })
          .then(res => this.handleFileUploadResponse(res));
      }
    }
  }

  handleFileUploadResponse(res) {
    var responseMessage
    if (res.data.message) {
      responseMessage = res.data.message
    }
    var fileUploadStatusMessage
    var fileUploadError
    if (responseMessage === 'success') {
      fileUploadStatusMessage = "Thank you. We'll send you an email as soon as we have processed the file."
    } else {
      if (responseMessage === 'A') {
        fileUploadError = "We already have a file with that name. Please rename the file and try again."
      } else if (responseMessage === 'F') {
        fileUploadError = "You are not allowed to upload files."
      } else {
        fileUploadError = "An unknown error occurred. Please try again."
      }
    }
    this.setState({
      fileUploadStatusIndicator: '',
      fileUploadStatusMessage: fileUploadStatusMessage,
      fileUploadError: fileUploadError,
      file: null,
      fileDisplayName: null
    });
  }

  handleClick() {
    this.refs.fileInput.click();
  }
  render() {
    var {
      addButtonProps,
      changeButtonProps
    } = this.props;
    return (
      <div className="fileinput">
        <input type="file" onChange={this.handleFileChange} ref="fileInput" />
        <div>
          {this.state.file === null ? (
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
              select file
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                change file
              </Button>
            </span>
          )}
          {this.state.fileDisplayName}
        </div>
        <div>
          <Button {...addButtonProps} onClick={() => this.handleFileUpload()}>
            {this.state.uploadButtonName}
          </Button>
          {this.state.fileUploadStatusIndicator} {this.state.fileUploadStatusMessage}
          <Danger>{this.state.fileUploadError}</Danger>
        </div>
      </div>
    );
  }
}

FileUpload.propTypes = {
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object
};

export default FileUpload;
